import { Flex, Image, Text, View } from "@aws-amplify/ui-react";
import { Grid, useMediaQuery } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

export default function ProgramEventsNav() {
  const matches = useMediaQuery("(min-width:800px)");
  const navigation = useNavigate();
  const [sidePanel, setsidePanel] = React.useState(false);
  const closeSidePanel = () => {
    setsidePanel(false);
  };
  const openSidePanel = () => {
    setsidePanel(true);
  };

  const handleDonationClicked = () => {
    window.open("https://donate.stripe.com/14kdSG6OF7Crcb65kk");
  };

  return (
    <Grid
      container
      position="fixed"
      display="flex"
      width="100vw"
      zIndex="9999"
      wrap="nowrap"
      // maxHeight="188px"
      // height="188px"
      // backgroundColor="rgba(57, 137, 70, 0.6)"
      // backgroundColor="rgba(55, 138, 69, 0.6)"
      // backgroundColor="rgba(57, 98, 64, 0.6)"
      bgcolor="rgba(32, 78, 41, 0.6)"
    >
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => {
          navigation("/");
        }}
      >
        <View
          // display={matches ? '' : 'none'}
          className="relative flex "
          paddingLeft="10px"
        >
          <Image
            src="/ehr.png"
            alt="Home Logo"
            width="180px"
            height="90px"
            // backgroundImage="red"
            objectFit="cover"
            position="relative"
          />
        </View>
      </motion.button>

      <View
        width="100%"
        className="relative flex flex-wrap gap-[15px] justify-end items-center"
        // backgroundColor="red"
        // height="70px"

        position="relative"
        paddingLeft="30px"
        paddingRight="30px"
        paddingBottom={matches ? "" : ""}
        // justifyContent="end"
        // alignItems="center"
        textAlign="center"
      >
        <motion.button
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => {
            navigation("/Home");
          }}
        >
          <View color="white" className="relative font-thin" fontSize="20px">
            <div className=" font-lolita-one">Home</div>
          </View>
        </motion.button>
        <View className=" text-white text-[40px] font-thin ">|</View>
        {/* Forms */}
        <motion.button whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
          <View
            color="white"
            fontSize="20px"
            className=" font-thin"
            onClick={openSidePanel}
          >
            <div className=" font-lolita-one">Forms</div>
          </View>
        </motion.button>
        <View
          display={matches ? "" : "none"}
          className=" text-white text-[40px] font-thin "
        >
          |
        </View>
        {/* Donate */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handleDonationClicked}
          style={{
            display: `${matches ? "" : "none"}`,
          }}
        >
          <Text
            display="flex"
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
            width="100px"
            height="50px"
            marginTop="5px"
            backgroundColor="rgba(32, 78, 41, 0.8)"
            borderRadius="5px"
            fontWeight="bold"
            color="white"
            className="focus:border-green active:border-green "
          >
            <div className=" font-lolita-one">Donate</div>
          </Text>
        </motion.button>
      </View>

      <Modal
        isOpen={sidePanel}
        onRequestClose={closeSidePanel}
        style={{
          overlay: {
            position: "fixed",
            display: "flex",
            justifyContent: "flex-end",
            height: "100vh",
            overflow: "scroll",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            zIndex: 9999,

            padding: "90px 0px 30px 0px",
          },

          content: {
            position: "relative",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            border: "0px solid #ccc",

            width: "300px",
            backgroundColor: "rgba(255,255,255,.9)",
            // backgroundColor:"rgba(32, 78, 41, 0.9)",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            height: "250px",
            // paddingLeft: "15px",
            // paddingRight: "15px",
            // display: "flex",
            // justifyContent:"center",

            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
            outline: "none",
            padding: "0px",
          },
        }}
      >
        <Text width="100%" textAlign="center" paddingTop="15px"></Text>
        <Flex
          position="relative"
          height="auto"
          gap="10px"
          width="100%"
          direction="column"
          paddingTop="15px"
          paddingLeft="30px"
          paddingRight="30px"
        >
          <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Text
              display="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              width="100%"
              height="40px"
              borderRadius="5px"
              border="1px solid #000000"
              textAlign="center"
              fontSize="14px"
              onClick={() => {
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLSePbc24N3psTbMBRSbBRK0820IRNkop57MDtb04rP6xgNIaqA/viewform?usp=sf_link",
                );
              }}
            >
              <div className=" font-lolita-one">
                Brownsville Skate Clinic Sign Up
              </div>
            </Text>
          </motion.button>
          <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Text
              display="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              width="100%"
              height="40px"
              borderRadius="5px"
              border="1px solid #000000"
              textAlign="center"
              fontSize="14px"
              onClick={() => {
                navigation("/VolunteerSignUp");
              }}
            >
              <div className=" font-lolita-one">Volunteer Sign Up</div>
            </Text>
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={openSidePanel}
          >
            <Text
              display="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              width="100%"
              height="40px"
              borderRadius="5px"
              border="1px solid #000000"
              fontSize="14px"
              onClick={() => {
                navigation("/Organization");
              }}
            >
              <div className=" font-lolita-one">Organization Sign Up</div>
            </Text>
          </motion.button>

          <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Text
              display="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              width="100%"
              height="40px"
              borderRadius="5px"
              border="1px solid #000000"
              textAlign="center"
              fontSize="14px"
              onClick={() => {
                navigation("/SkaterSignUp");
              }}
            >
              <div className=" font-lolita-one">First Saturday Sk8 Sign Up</div>
            </Text>
          </motion.button>
        </Flex>
      </Modal>
    </Grid>
  );
}
